// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"015dad5f","369":"fc527441"}[chunkId] + ".chunk.js";
};